/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 使用場所情報
 */
export interface Sgkb575aResEmpposInfo {
    /** 
     * 使用場所需要家区分：半角英数混在
     */
    empposDmdiv?: string;
    /** 
     * 使用場所需要家区分名称：全角半角混在
     */
    empposDmdivAname?: string;
    /** 
     * 使用場所住所コード：半角英数混在
     */
    empposAddrcd?: string;
    /** 
     * 使用場所郵便番号：半角数字
     */
    empposPostno?: string;
    /** 
     * 使用場所都道府県名称：全角文字
     */
    empposPfcAname?: string;
    /** 
     * 使用場所市区郡町村名称：全角文字
     */
    empposMptAname?: string;
    /** 
     * 使用場所町域名称：全角文字
     */
    empposTwareaAname?: string;
    /** 
     * 使用場所大字丁目名称：全角文字
     */
    empposOazaAname?: string;
    /** 
     * 使用場所住所番地・号・分筆号：全角文字
     */
    empposAddrBlockgoulot?: string;
    /** 
     * 使用場所住所番地・号・分筆号（カナ）：全角英数カナ
     */
    empposAddrBlockgoulotkana?: string;
    /** 
     * 使用場所住宅・棟号漢字名：全角文字
     */
    empposSupadrAname?: string;
    /** 
     * 使用場所住宅・棟号カナ名：全角文字
     */
    empposSupadrKananm?: string;
    /** 
     * 使用場所屋号・業種漢字名：全角文字
     */
    empposYagouAname?: string;
    /** 
     * 使用場所屋号・業種カナ名：全角文字
     */
    empposYagouKananm?: string;
    /** 
     * 使用場所表示住所漢字：全角文字
     */
    empposAddrAnameF?: string;
}
